
/// <amd-module name="Build/Admin/AgentCloudsList/Actions/ActionsHub" />
import { AgentCloudActions } from "Build/Admin/Common/Actions/AgentCloudActions";
import { NotificationActions } from "Build/Admin/Common/Actions/NotificationActions";

export class ActionsHub {
    public notificationActions = new NotificationActions();
    public agentCloudActions = new AgentCloudActions();
}
